if (typeof customElements.get("info-tabs") === 'undefined') {
class InfoTabs extends HTMLElement {
    constructor() {
      super();
  
      this.tabsElement = this.querySelector(".info-tabs");
      this.tabsListContainer = this.querySelector(".info-tabs-header-container");
      this.tabs = this.querySelectorAll(".info-tabs-header");
      this.tabButtons = this.querySelectorAll(".info-tabs-header-button");
      this.tabContent = this.querySelectorAll(".info-tabs-content");
      this.activeTabIndex = 1;
      this.savedFocusElement = null;
      this.activeTab = this.querySelector(".info-tabs-header-button.active");
      this.bindEvents();
    }
  
    connectedCallback() {
  
    }
  
    bindEvents() {
      this.tabButtons.forEach((button) => {
        button.addEventListener('focus', this.onTabFocus.bind(this));
        button.addEventListener('keydown', this.onKeyDown.bind(this));
      }
      );
  
      this.tabContent.forEach((content) => {
        content.addEventListener('keydown', this.onContentKeyDown.bind(this));
      }
      );
    }
  
  
    onTabFocus(event) {
      this.savedFocusElement = event.target;
      this.activeTabIndex = event.target.dataset.index;
  
      this.tabButtons.forEach((tab) => {
        let tabIndex = tab.dataset.index;
        if (tabIndex == this.activeTabIndex) {
          tab.classList.add("active");
          tab.setAttribute('aria-selected', true);
          tab.setAttribute('tabindex', 0);
          this.activeTab = tab;
          tab.scrollIntoView({ behavior: 'smooth', block: "nearest" });
        } else {
          tab.classList.remove("active");
          tab.setAttribute('aria-selected', false);
          tab.setAttribute('tabindex', -1);
        }
      }
      );
  
      this.tabContent.forEach((tabContent) => {
        let tabIndex = tabContent.dataset.index;
        if (tabIndex == this.activeTabIndex) {
          tabContent.classList.add("active");
          tabContent.setAttribute('tabindex', 0);
        } else {
          tabContent.classList.remove("active");
          tabContent.setAttribute('tabindex', -1);
        }
      }
      );
  
    }
  
    onContentKeyDown(event) {
      if (event.code.toUpperCase() == 'TAB') {
        if (event.shiftKey && event.target.classList.contains("info-tabs-content")) {
          event.preventDefault();
          this.querySelector(".info-tabs-header-button.active").focus();
        }
      }
    }
  
  
    onKeyDown(event) {
      let tab = event.target;
      let tabIndex = parseInt(event.target.dataset.index);
      let correctedTabIndex = tabIndex - 1;
      let previousTabIndex = correctedTabIndex - 1;
      let nextTabIndex = tabIndex;
      if (correctedTabIndex == 0) {
        previousTabIndex = this.tabButtons.length - 1;
      } else if (correctedTabIndex == (this.tabButtons.length - 1)) {
        nextTabIndex = 0;
      }
      if (event.code.toUpperCase() == 'TAB') {
        if (event.shiftKey) {
        } else {
          event.preventDefault();
          this.tabContent[correctedTabIndex].focus();
        }
  
      }
      switch (event.key) {
        case "ArrowLeft":
          this.tabButtons[previousTabIndex].focus();
          break;
        case "ArrowRight":
          this.tabButtons[nextTabIndex].focus();
          break;
      }
    }
  }
  
  customElements.define('info-tabs', InfoTabs);
}
  